import { merge } from '@/utils';

export function getVexTableProps(
  props,
  option = {
    replace: false
  }
) {
  const defaultProps = {
    align: 'center',
    border: true,
    columnConfig: {
      resizable: true
    },
    toolbarConfig: {
      custom: true,
      refresh: true,
      zoom: true
    },
    pagerConfig: {
      pageSize: 10,
      currentPage: 1
    },
    props: {
      result: 'result',
      total: 'total'
    },
    proxyConfig: props.proxyConfig
      ? merge(props.proxyConfig, { props: { result: 'result', total: 'total' } })
      : null
  };
  return merge(defaultProps, props, option);
}

export const dateFormat = 'YYYY-MM-DD';

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const auditStatusOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '待审核',
    value: '0'
  },
  {
    label: '通过',
    value: '1'
  },
  {
    label: '驳回',
    value: '2'
  }
];

export const administratorOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '省级团队',
    value: '3'
  },
  {
    label: '市级团队',
    value: '2'
  },
  {
    label: '区/县级团队',
    value: '1'
  }
];

export const platformNoticeOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '资讯公告',
    value: '1'
  },
  {
    label: '荣誉之心',
    value: '2'
  },
  {
    label: '活动信息',
    value: '3'
  },
  {
    label: '业务技能',
    value: '4'
  },
  {
    label: '平台消息',
    value: '5'
  }
];

export const menuIconMap = {
  账号及角色管理: 'User',
  商品管理: 'Goods',
  内容管理: 'Document',
  下载中心: 'Download',
  控销团队管理: 'Share',
  订单管理: 'Tickets',
  系统安全: 'Setting',
  积分管理: 'Coin',
  学术管理: 'Management',
  客户管理: 'Avatar',
  数据管理: 'DataBoard',
  营销中心: 'ShoppingCartFull',
  招商管理: 'Connection',
  品种管理: 'Goods',
  招人: 'UserFilled',
  招人管理: 'UserFilled',
  直播管理: 'VideoCamera',
  平台数据分析: 'PieChart',
  '目标/任务管理': 'List',
  资信管理: 'Ticket',
  分账管理: 'Discount',
  资金管理: 'ShoppingCartFull',
};

export const employeeTypeMap = {
  1: '企业负责人',
  2: '部门负责人',
  3: '业务员'
};
